import { render, staticRenderFns } from "./EquipmentVanCollapseContent.vue?vue&type=template&id=4ce1ecbb&scoped=true"
import script from "./EquipmentVanCollapseContent.vue?vue&type=script&lang=js"
export * from "./EquipmentVanCollapseContent.vue?vue&type=script&lang=js"
import style0 from "./EquipmentVanCollapseContent.vue?vue&type=style&index=0&id=4ce1ecbb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce1ecbb",
  null
  
)

export default component.exports